export const MODULE_NAME = 'misc';
export const PROP_FRIENDS_AND_FAMILY = 'experimentalFriendsAndFamilyMemberFeatures';
export const TOGGLE = 'toggle';
